export default __webpack_public_path__ + "static/media/tm.06eedd0f.svg";